import { useContext } from 'react';
import HallPasses from '../HallPasses/HallPasses';
import { UserContext } from '../../contexts/UserContext';
import { LogOut } from 'lucide-react';

const CsoDashboard: React.FC = () => {
  const { userProfile, handleLogout } = useContext(UserContext);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-bold">CSO: {userProfile?.name}</div>
        <button
          onClick={handleLogout}
          className="text-sm text-indigo-600 underline">
          <LogOut className="w-5 h-5" />
        </button>
      </div>
      <HallPasses />
    </div>
  );
};

export default CsoDashboard;
